import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Header from "./components/common/layout/Header";
import BreadCrumb from "./components/common/layout/BreadCrumb";
import AppRoutes from "./AppRoutes";
import useConsoleLog from "./hooks/useInit/useConsoleLog";
import Modal from "./components/common/Modal/Modal";

const App = () => {
  useConsoleLog();
  return (
    <Router>
      <Header />
      <BreadCrumb />
      <ToastContainer position="bottom-right" />
      <main role="main" className="main-content" style={{ minHeight: "100%" }}>
        <AppRoutes />
      </main>
      <Modal />
    </Router>
  );
};

export default App;
